export default __webpack_public_path__ + "static/media/Chevron_right.8f88dacb.svg";